<template>
  <div class="pa-5">
    <v-data-table
      :headers="changeDetailDataTableHeaders"
      :items="changeDetailList"
      class="elevation-1"
      :loading="isLoadingChangeDetail"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :header-props="headerProps"
      :search="searchChangeDetail"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>變更作業</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchChangeDetail"
            append-icon="mdi-magnify"
            :label="$t('point_search_label')"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <v-btn
            color="primary"
            dark
            class="mb-2 ml-8"
            @click="isShowEditChangeDetailDialog = true"
            :disabled="isAllTextFieldDisable"
          >
            {{ $t('common_new') }}
          </v-btn>
          <v-dialog
            v-model="isShowEditChangeDetailDialog"
            v-if="isShowEditChangeDetailDialog"
            fullscreen
            persistent
          >
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ dialogTitleHeader }}</span>
                <v-spacer></v-spacer>
                <v-btn text small @click="closeEditedChangeDetail" class="mx-2">
                  <v-icon>
                    mdi-close-circle-outline
                  </v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-row class="mt-2">
                  <v-btn
                    color="primary"
                    :disabled="editedChangeDetailIndex === -1 || editedChangeDetail.IsThrow"
                    class="mx-2"
                    @click="throwChangeDetail"
                  >
                    拋轉變更單據
                  </v-btn>
                  <v-btn
                    color="green darken-1"
                    fab
                    small
                    class="mx-2"
                    text
                    @click="saveEditedChangeDetail"
                    :loading="isLoadingSaveBtn"
                    :disabled="isAllTextFieldDisable || editedChangeDetail.IsThrowMonth"
                  >
                    <v-icon>
                      mdi-content-save
                    </v-icon>
                  </v-btn>
                </v-row>
              </v-card-text>
              <v-card-text>
                <v-container>
                  <ValidationObserver ref="changeDetail">
                    <v-row>
                      <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                        <ValidationProvider
                          :name="$t('point_type')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-autocomplete
                            v-model="editedChangeDetail.Type"
                            :items="changeDetailTypeList"
                            item-text="Name"
                            item-value="Type"
                            required
                            :loading-text="$t('common_get_data')"
                            :no-data-text="$t('common_no_results')"
                            @keyup.enter="setTypeAutocomplete"
                            ref="typeAutocomplete"
                            :error-messages="errors[0]"
                            @change="changeType"
                            :disabled="isAllTextFieldDisable"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('point_type') }}
                            </template>
                          </v-autocomplete>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                        <date-picker-set-time
                          :time="editedChangeDetail.ChangeTime"
                          :dateName="'month_item_change_date'"
                          :isAllTextFieldDisabled="isAllTextFieldDisable"
                          @setDate="setChangeTime"
                          @keyupEnter="focusNextInput"
                        />
                      </v-col>
                    </v-row>
                    <div v-if="editedChangeDetail.Type === 1">
                      <v-row>
                        <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                          <license-plate-autocomplete
                            :fatherOriginalLicensePlate="editedChangeDetail.OriginalLicensePlate"
                            refName="licensePlateAutocomplete"
                            :isAllTextFieldDisable="isAllTextFieldDisable"
                            @changeLicensePlate="changeLicensePlate"
                            v-if="!editedChangeDetail.IsThrow"
                          />
                          <v-text-field
                            v-model="editedChangeDetail.OriginalLicensePlate"
                            :label="$t('change_detail_old_license_plate')"
                            disabled
                            v-else
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                          <ValidationProvider
                            :name="$t('change_detail_license_plate')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              v-model="editedChangeDetail.LicensePlate"
                              :label="$t('change_detail_license_plate')"
                              :disabled="isAllTextFieldDisable"
                              :error-messages="errors[0]"
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                          <v-checkbox
                            v-model="editedChangeDetail.IsAllChange"
                            label="是否變更全部"
                            :disabled="isAllTextFieldDisable"
                            @click="changeIsAllChange"
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                    </div>
                    <div v-else>
                      <v-row>
                        <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                          <customer-autocomplete-for-change-detail
                            refName="customerAutocomplete"
                            :fatherEditedCustomer="editedChangeDetail.OriginalCustomer"
                            :customerName="'change_detail_old_customer_number'"
                            @setCustomer="setOriginalCustomer"
                            :isAllTextFieldDisable="isAllTextFieldDisable"
                          />
                        </v-col>
                        <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                          <license-plate-autocomplete-multiple-by-customer-id
                            v-if="!editedChangeDetail.IsThrow"
                            :customerId="editedChangeDetail.OriginalCustomer.Id"
                            :fatherLicensePlateList="editedChangeDetail.LicensePlateList"
                            :isAllTextFieldDisable="isAllTextFieldDisable"
                            @setLicensePlate="setLicensePlate"
                          />
                          <v-text-field
                            v-model="editedChangeDetail.LicensePlateList"
                            disabled
                            :label="$t('change_detail_license_plates')"
                            v-else
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                          <customer-autocomplete-for-change-detail
                            refName="customerAutocomplete"
                            :fatherEditedCustomer="editedChangeDetail.Customer"
                            :customerName="'change_detail_customer_number'"
                            @setCustomer="setCustomer"
                            :isAllTextFieldDisable="isAllTextFieldDisable"
                          />
                        </v-col>
                      </v-row>
                    </div>
                  </ValidationObserver>
                </v-container>
              </v-card-text>
              <v-tabs>
                <v-tab
                  href="#tab-1"
                  v-if="editedChangeDetail.Type === 1 && !editedChangeDetail.IsAllChange"
                >
                  變更月租品項清單
                </v-tab>
                <v-tab-item
                  value="tab-1"
                  v-if="editedChangeDetail.Type === 1 && !editedChangeDetail.IsAllChange"
                >
                  <v-card flat>
                    <change-detail-month-item
                      :monthList="editedChangeDetail.MonthItems"
                      :isAllTextFieldDisable="isAllTextFieldDisable"
                      @confirmDeleteMonthItem="confirmDeleteMonthItem"
                    />
                  </v-card>
                </v-tab-item>
              </v-tabs>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="closeEditedChangeDetail"
                  :disabled="isLoadingSaveBtn"
                >
                  {{ $t('common_cancel') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <delete-dialog
            :isAllTextFieldDisable="isAllTextFieldDisable"
            :isLoadingSaveBtn="isLoadingDeleteBtn"
            :isShowDeleteDialog="isShowDeleteChangeDetailDialog"
            :deleteMessage="'change_detail_delete_message'"
            @closeDelete="closeDeleteChangeDetail"
            @confirmDelete="confirmDeleteChangeDetail"
          />
        </v-toolbar>
      </template>
      <template v-slot:[`item.ChangeTime`]="{ item }">
        {{ convertToDateTimeFormat(item.ChangeTime) }}
      </template>
      <template v-slot:[`item.Type`]="{ item }">
        {{ turnFormType(item.Type) }}
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn icon small @click="isShowEditChangeDetailBtn(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn v-if="!item.IsThrow" icon small @click="isShowDeleteChangeDetailBtn(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { HttpChangeDetail, HttpMonth } from '@/js/http-Manager'
import { ChangeDetailType } from '@/js/ChangeDetailType'
import DeleteDialog from '@/components/DeleteDialog.vue'
import CustomerAutocompleteForChangeDetail from '@/components/ChangeDetail/CustomerAutocompleteForChangeDetail.vue'
import LicensePlateAutocomplete from '@/components/ChangeDetail/LicensePlateAutocomplete.vue'
import DatePickerSetTime from '@/components/DatePickerSetTime.vue'
import ChangeDetailMonthItem from '@/components/ChangeDetail/ChangeDetailMonthItem.vue'
import LicensePlateAutocompleteMultipleByCustomerId from '@/components/ChangeDetail/LicensePlateAutocompleteMultipleByCustomerId.vue'

export default {
  name: 'ChangeDetail',
  components: {
    DeleteDialog,
    CustomerAutocompleteForChangeDetail,
    LicensePlateAutocomplete,
    DatePickerSetTime,
    ChangeDetailMonthItem,
    LicensePlateAutocompleteMultipleByCustomerId
  },
  data: () => ({
    isShowEditChangeDetailDialog: false,
    changeDetailList: [],
    editedChangeDetailIndex: -1,
    searchChangeDetail: '',
    editedChangeDetail: {
      Number: '',
      Type: 1,
      LicensePlate: '',
      ChangeTime: 0,
      OriginalLicensePlate: '',
      Customer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: ''
      },
      OriginalCustomer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: ''
      },
      LicensePlateList: [],
      IsThrow: false,
      Status: 0,
      IsAllChange: true,
      MonthItems: []
    },
    defaultChangeDetail: {
      Number: '',
      Type: 1,
      LicensePlate: '',
      ChangeTime: 0,
      OriginalLicensePlate: '',
      Customer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: ''
      },
      OriginalCustomer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: ''
      },
      LicensePlateList: [],
      IsThrow: false,
      Status: 0,
      IsAllChange: true,
      MonthItems: []
    },
    isLoadingChangeDetail: true,
    isLoadingSaveBtn: false,
    isAllTextFieldDisable: false,
    isShowDeleteChangeDetailDialog: false,
    isLoadingDeleteBtn: false,
    isDeleteBtnDisable: false,
    changeDetailTypeList: []
  }),
  async mounted () {
    this.getAllChangeDetail()
    this.getAllChangeDetailType()
  },
  computed: {
    changeDetailDataTableHeaders () {
      return [
        {
          text: this.$t('point_type'),
          align: 'start',
          value: 'Type'
        },
        { text: '單號', align: 'start', value: 'Number' },
        { text: this.$t('month_item_change_date'), align: 'start', value: 'ChangeTime' },
        {
          text: this.$t('change_detail_old_license_plate'),
          align: 'start',
          value: 'OriginalLicensePlate'
        },
        {
          text: this.$t('change_detail_license_plate'),
          align: 'start',
          value: 'LicensePlate'
        },
        {
          text: this.$t('change_detail_old_customer_number'),
          align: 'start',
          value: 'OriginalCustomer.Number'
        },
        {
          text: this.$t('change_detail_old_customer_short_name'),
          align: 'start',
          value: 'OriginalCustomer.ShortName'
        },
        {
          text: this.$t('change_detail_old_customer_full_name'),
          align: 'start',
          value: 'OriginalCustomer.FullName'
        },
        {
          text: this.$t('change_detail_customer_number'),
          align: 'start',
          value: 'Customer.Number'
        },
        {
          text: this.$t('change_detail_customer_short_name'),
          align: 'start',
          value: 'Customer.ShortName'
        },
        {
          text: this.$t('change_detail_customer_full_name'),
          align: 'start',
          value: 'Customer.FullName'
        },

        {
          text: this.$t('change_detail_license_plates'),
          align: 'start',
          value: 'LicensePlateList',
          sortable: false
        },
        {
          text: this.$t('common_edit'),
          align: 'center',
          value: 'Edit',
          sortable: false
        }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    turnFormTypeName () {
      return ChangeDetailType.ChangeDetailTypeName(this.editedChangeDetail.Type)
    },
    dialogTitleHeader () {
      return this.editedChangeDetailIndex === -1 ? this.$t('common_new') : this.$t('common_edit')
    }
  },
  methods: {
    async throwChangeDetail () {
      await HttpChangeDetail.ThrowChangeDetail(this.editedChangeDetail)
      this.closeEditedChangeDetail()
      await this.getAllChangeDetail()
    },
    changeType () {
      let tempType = this.editedChangeDetail.Type
      this.editedChangeDetail = JSON.parse(JSON.stringify(this.defaultChangeDetail))
      this.editedChangeDetail.Type = tempType
    },
    setTypeAutocomplete (event) {
      this.$refs.typeAutocomplete.isMenuActive = false
      this.$refs.typeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (
          form[i].type !== 'hidden' &&
          !form[i].disabled &&
          !form[i].readOnly &&
          form[i].type !== 'checkbox'
        ) {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },

    async getAllChangeDetailType () {
      let response = await HttpChangeDetail.GetChangeDetailTypes()

      this.changeDetailTypeList = response.status === 200 ? response.data.Data : []
    },
    turnFormType (val) {
      return ChangeDetailType.ChangeDetailTypeName(val)
    },
    async getAllChangeDetail () {
      this.isLoadingChangeDetail = true

      let response = await HttpChangeDetail.GetChangeDetails()
      this.isLoadingChangeDetail = false
      if (response) {
        this.changeDetailList = response.status === 200 ? response.data.Data : []
      }
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    isShowEditChangeDetailBtn (item) {
      this.editedChangeDetailIndex = this.changeDetailList.indexOf(item)
      this.editedChangeDetail = JSON.parse(JSON.stringify(item))
      if (item.IsThrow) {
        this.isAllTextFieldDisable = true
      }
      this.isShowEditChangeDetailDialog = true
    },
    closeEditedChangeDetail () {
      this.isShowEditChangeDetailDialog = false
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false

      this.$nextTick(() => {
        this.editedChangeDetail = JSON.parse(JSON.stringify(this.defaultChangeDetail))
        this.editedChangeDetailIndex = -1
      })
    },

    async saveEditedChangeDetail () {
      let isError = false
      if (this.editedChangeDetail.Type === 1) {
        let response = await HttpMonth.GetMonthExistLicensePlateError(this.editedChangeDetail)
        if (response && response.status === 200) {
          let errorList = response.data.Data
          if (errorList.length > 0) {
            isError = true
            alert(errorList.join('\n'))
          }
        }
      }
      if (!isError) {
        const isValid = await this.$refs.changeDetail.validate()
        if (isValid) {
          this.isLoadingSaveBtn = true
          this.isAllTextFieldDisable = true
          this.isLoadingChangeDetail = true

          if (this.editedChangeDetailIndex !== -1) {
            await HttpChangeDetail.UpdateChangeDetail(this.editedChangeDetail)
          } else {
            await HttpChangeDetail.AddChangeDetail(this.editedChangeDetail)
          }
          await this.getAllChangeDetail()
          this.closeEditedChangeDetail()
        }
      }
    },
    isShowDeleteChangeDetailBtn (item) {
      this.editedChangeDetailIndex = this.changeDetailList.indexOf(item)
      this.isShowDeleteChangeDetailDialog = true
    },
    async confirmDeleteChangeDetail () {
      this.isLoadingDeleteBtn = true
      this.isDeleteBtnDisable = true
      this.isLoadingChangeDetail = true
      await HttpChangeDetail.DeleteChangeDetail(
        this.changeDetailList[this.editedChangeDetailIndex].Id
      )
      this.isLoadingDeleteBtn = false
      this.isDeleteBtnDisable = false
      this.isLoadingChangeDetail = false
      await this.getAllChangeDetail()
      this.closeDeleteChangeDetail()
    },

    closeDeleteChangeDetail () {
      this.isShowDeleteChangeDetailDialog = false
      this.$nextTick(() => {
        this.editedChangeDetailIndex = -1
      })
    },
    setOriginalCustomer (val) {
      this.editedChangeDetail.OriginalCustomer = JSON.parse(JSON.stringify(val))
    },
    setCustomer (val) {
      this.editedChangeDetail.Customer = JSON.parse(JSON.stringify(val))
    },
    setLicensePlate (val) {
      this.editedChangeDetail.LicensePlateList = val
    },
    async changeIsAllChange () {
      if (!this.editedChangeDetail.IsAllChange && this.editedChangeDetail.OriginalLicensePlate) {
        await this.getMonthList()
      } else {
        this.editedChangeDetail.MonthItems = []
      }
    },
    async changeLicensePlate (val) {
      this.editedChangeDetail.OriginalLicensePlate = val
      await this.changeIsAllChange()
    },
    async getMonthList () {
      let param = {
        licensePlate: this.editedChangeDetail.OriginalLicensePlate
      }
      let monthResponse = await HttpMonth.GetMonthListByLicensePlate(param)
      if (monthResponse && monthResponse.status === 200) {
        this.editedChangeDetail.MonthItems = []
        monthResponse.data.Data.forEach((element) => {
          if (element.MonthStatus === 1) {
            let temp = {
              Id: element.ItemId,
              Number: element.ItemNumber,
              Name: element.ItemName,
              MonthNumber: element.Number,
              Unit: element.ItemUnit,
              DiscountPrice: element.OriginalCurrency * 1,
              Discount: 0,
              Quantity: element.OverageMonthQuantity * 1,
              RentQuantity: 1,
              Price: element.OriginalCurrency * 1,
              TotalPrice: element.OverageMonthQuantity * element.OriginalCurrency * 1,
              RentWarrantyPeriod: element.RentWarrantyPeriod * 1,
              PayType: element.PayType,
              Remark: element.Remark
            }
            this.editedChangeDetail.MonthItems.push(temp)
          }
        })
      }
    },
    setChangeTime (val) {
      this.editedChangeDetail.ChangeTime = val * 1
    },
    confirmDeleteMonthItem (item) {
      let index = this.editedChangeDetail.MonthItems.indexOf(item)
      this.editedChangeDetail.MonthItems.splice(index, 1)
    }
  }
}
</script>
